/**
 * Password Recovery Page
 * Redirects users to the WhatsApp bot for password recovery
 */

import { Link } from 'react-router-dom'
import { Card } from '@shared/components/ui/card'
import { Button } from '@shared/components/ui/button'
import { useBotContact, openWhatsAppChat } from '@shared/lib/api'
import { MessageCircle } from 'lucide-react'

const RECOVERY_MESSAGE = 'Quiero recuperar mi contraseña'
const FALLBACK_BOT_NUMBER = '5493412618612'

export function PasswordRecoveryPage() {
  const { data: botContact } = useBotContact()

  const handleWhatsAppRedirect = () => {
    const phoneNumber = botContact ?? FALLBACK_BOT_NUMBER
    openWhatsAppChat(phoneNumber, RECOVERY_MESSAGE)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-auth bg-cover bg-center p-4">
      <Card className="w-full max-w-md p-6 shadow-sm">
        <h1 className="text-2xl mb-6 font-bold text-center">Recuperar Contraseña</h1>

        <div className="space-y-6">
          {/* Explanation */}
          <div className="text-center text-muted-foreground">
            <p>
              Para recuperar tu contraseña, te conectaremos con nuestro asistente de WhatsApp.
            </p>
          </div>

          {/* WhatsApp Button */}
          <Button
            type="button"
            className="w-full bg-green-600 hover:bg-green-700 text-white"
            onClick={handleWhatsAppRedirect}
          >
            <MessageCircle className="mr-2 h-4 w-4" />
            Recuperar por WhatsApp
          </Button>

          {/* Login Link */}
          <div className="text-center text-sm text-muted-foreground">
            ¿Ya tienes una cuenta?{' '}
            <Link to="/login" className="text-primary hover:underline">
              Iniciar sesión
            </Link>
          </div>
        </div>
      </Card>
    </div>
  )
}
